"use client"

import { Fragment } from 'react'
import Carousel from "@/components/common/Carousel"
import { TypeStoreDetail } from "@/lib/redux/features/store/type"
import { Button, Col, Row, Skeleton } from "antd"

const CategoriesNavigationSkeleton = ({ store }: { store: TypeStoreDetail }) => {
  const isCrowdaa = store.platform_name === 'crowdaa'
  const hiddenStoreName = !!store.hidden_store_name || isCrowdaa

  if (`${store.shown_categories}` !== '2') {
    return <Fragment />
  }

  return (
    <Col
      span={24}
      style={{
        borderTop: `2px solid ${store.theme.color_primary}`,
        borderBottom: `2px solid ${store.theme.color_primary}`,
        position: 'sticky',
        top: '6.4rem',
        zIndex: 1,
        backdropFilter: 'blur(100px)'
      }}
      className={`home__navigation${hiddenStoreName || `${store.shown_categories}` === '2' ? ' hidden--store_name': ''}`}
    >
      <Row justify='center' style={{ marginInline: '-0.5rem', overflow: 'hidden' }} wrap={false}>

        {Array(20).fill(null).map((_, idx) => {
          return (
            <Col key={idx} style={{ paddingInline: '0.5rem' }}>
              <Skeleton.Button active style={{ width: '12rem', maxHeight: 'unset', height: '4rem', borderRadius: 0 }} />
            </Col>
          )
        })}
      </Row>
    </Col>
  )
}

export default CategoriesNavigationSkeleton